export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.14a053abac202813b0be2fbf20091086.css";